import { IAccess, IProduct } from "../../fetchOrderProducts";

export function isAccess(product: IProduct): product is IAccess {
  return "specificationId" in product && product.specificationId === "ACCESS";
}
